import { render } from "./OptStatViewManager.vue?vue&type=template&id=22d72c64&scoped=true"
import script from "./OptStatViewManager.vue?vue&type=script&lang=js"
export * from "./OptStatViewManager.vue?vue&type=script&lang=js"

import "./OptStatViewManager.vue?vue&type=style&index=0&id=22d72c64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d72c64"]])

export default __exports__